import { createSelector } from 'reselect';

export const canExport = state => state.ui.canExport;
export const getCurrentTab = state => state.ui.currentTab;
export const getDefaultLeaseColumns = state => state.ui.defaultLeaseColumns;
export const getDefaultSaleColumns = state => state.ui.defaultSaleColumns;
export const getCurrentView = state => state.ui.currentView;

export const getDefaultColumns = createSelector(
  [getCurrentTab, getDefaultLeaseColumns, getDefaultSaleColumns],
  (currentTab, leaseColumns, saleColumns) => (
    currentTab === 'lease' ? leaseColumns : saleColumns
  )
);
